import { ContentType, Result } from '@standardnotes/domain-core';
import { BackupFileType } from '@standardnotes/encryption';
import { isDecryptedPayload, isEncryptedPayload } from '@standardnotes/models';
export class GetBackupFileType {
    execute(file, payloads) {
        if (file.keyParams || file.auth_params) {
            return Result.ok(BackupFileType.Encrypted);
        }
        const hasEncryptedItem = payloads.find(isEncryptedPayload);
        const hasDecryptedItemsKey = payloads.find((payload) => payload.content_type === ContentType.TYPES.ItemsKey && isDecryptedPayload(payload));
        if (hasEncryptedItem && hasDecryptedItemsKey) {
            return Result.ok(BackupFileType.EncryptedWithNonEncryptedItemsKey);
        }
        else if (!hasEncryptedItem) {
            return Result.ok(BackupFileType.FullyDecrypted);
        }
        else {
            return Result.ok(BackupFileType.Corrupt);
        }
    }
}
